import { responseStatus } from "../constants";
import { ApiPaths } from "../helpers/api";
import { ChiTietKhenThuongUngHoResponse, ChiTietPhatSinhTinhThueResponse, ChiTietLuongThanhPhan, DanhSachKhenThuongUngHoResponse, DsOptionsLuongThanhPhan, ImportFileLPS, LuongDataTable, NhanVien_MucLuong_PhuCap } from "../models/luong/Luong";
import { TongHopThuNhap } from "../models/luong/Luong";
import intance from "../utils/axios";
import { ChiTietLuongBoSungResponse, DanhSachLuongBoSungResponse, ImportFileLuongBoSungRequest, LuongBoSungNLDResponse, LuongBoSungResponse } from "../models/luong/LuongBoSung";
import { DuLieuQuyetToanThueResponse, ChiTietThueThangItem } from "../models/thue/Thue";
import { PhuCapTGV } from "../models/luong/PhuCapTGV";

export const layDuLieuDSLuong = async (date: string) => {
    var rs: Array<LuongDataTable> = [];
    await intance.get(ApiPaths.luong.quanLyLuong + "?thoiGian=" + date)
        .then((res) => {
            if (res.data.trangThai == responseStatus.thanhCong) {
                rs = res.data.duLieu;
            } else {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
    return rs;
};

export const khoiTaoKyLuong = async (thang: number, nam: number, loai: number) => {
    var rs = 0;
    await intance.get(ApiPaths.luong.themKyLuong + "?thang=" + thang + "&nam=" + nam + "&loai=" + loai)
        .then((res) => {
            if (res.data.trangThai == responseStatus.thanhCong) {
                rs = res.data.duLieu;
            } else {
                throw Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });

    return rs;
}

export const getKyLuong = async (thang: any, nam: any, loai: number) => {
    var rs: TongHopThuNhap = new TongHopThuNhap();
    await intance.get(ApiPaths.luong.get + "?thang=" + thang + "&nam=" + nam + "&loai=" + loai)
        .then((res) => {
            if (res.data.trangThai == responseStatus.thanhCong) {
                rs = res.data.duLieu;
            } else {
                throw Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
    return rs;
};

export const dieuChinhBangLuongThang = async (data: any) => {
    var rs: TongHopThuNhap = new TongHopThuNhap();
    await intance.post(ApiPaths.luong.dieuChinhBangLuongThang, data)
        .then((res) => {
            if (res.data.trangThai == responseStatus.thanhCong) {
                rs = res.data.duLieu;
            } else {
                throw Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
    return rs;
}

export const xuatDuLieuLuongBoSung = async (idNhomNhanSu: number, tongLuongDuocNhan: number, quyQuyetToan: number, namQuyetToan: number) => {
    var rs: any;
    await intance.post(ApiPaths.luong.xuatLuongBoSung, {
        "idNhomNhanSu": idNhomNhanSu,
        "quyQuyetToan": quyQuyetToan,
        "namQuyetToan": namQuyetToan,
        "tongLuongDuocNhan": tongLuongDuocNhan,
    },
        { responseType: 'blob' })
        .then((res) => {
            rs = res;
        })
        .catch((err) => {
            throw 'Có lỗi xảy ra. Vui lòng thử lại';
        });
    return rs;
};

export const importFileLuongBoSung = async (request: ImportFileLuongBoSungRequest) => {
    var rs: Array<LuongBoSungResponse> = [];
    await intance.post(ApiPaths.luong.importFileChamCong,
        request,
        {
            headers: {
                "Content-Type": "multipart/form-data",
                "Accept": "application/json",
            },
        }
    )
        .then((res) => {
            if (res.data.trangThai === responseStatus.thanhCong) {
                rs = res.data.duLieu;
            } else {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw 'Có lỗi xảy ra. Vui lòng thử lại';
        });
    return rs;
};

export const luuLuongBoSung = async (request: any) => {
    var rs: number = 0;
    await intance.post(ApiPaths.luong.luuLuongBoSung, request).then((res) => {
        if (res.data.trangThai === responseStatus.thanhCong) {
            rs = res.data.duLieu;
        } else {
            throw new Error(res.data.thongBao);
        }
    }).catch((err) => {
        throw 'Có lỗi xảy ra. Vui lòng thử lại';
    });

    return rs;
};

export const luuLuongBoSungNLD = async (request: any) => {
    var rs: number = 0;
    await intance.post(ApiPaths.luong.luuLuongBoSungNLD, request).then((res) => {
        if (res.data.trangThai === responseStatus.thanhCong) {
            rs = res.data.duLieu;
        } else {
            throw new Error(res.data.thongBao);
        }
    }).catch((err) => {
        throw err;
    });

    return rs;
};

export const xuatExcelLuongBoSungNLD = async (id: number) => {
    var rs: any;
    await intance.get(ApiPaths.luong.xuatExcelLuongBoSungNLD + "?id=" + id, { responseType: 'blob' })
        .then((res) => {
            rs = res;
        })
        .catch((err) => {
            throw 'Có lỗi xảy ra. Vui lòng thử lại';
        });
    return rs;
}

export const layDuLieuLuongBoSung = async (idNhomNhanSu: number, namQuyetToan: number, quy: number) => {
    var rs: Array<LuongBoSungResponse> = [];
    await intance.post(ApiPaths.luong.layDuLieuLuongBoSung + "?idNhomNhanSu=" + idNhomNhanSu + "&namQuyetToan=" + namQuyetToan + "&quy=" + quy).then((res) => {
        if (res.data.trangThai === responseStatus.thanhCong) {
            rs = res.data.duLieu;
        } else {
            throw new Error(res.data.thongBao);
        }
    }).catch((err) => {
        throw 'Có lỗi xảy ra. Vui lòng thử lại';
    });

    return rs;
};



export const luuDuLieuThuNhapTinhThue = async (data: any) => {
    await intance.post(ApiPaths.luong.luuDuLieuThuNhapTinhThue, data)
        .then((res) => {
            if (res.data.trangThai === responseStatus.thanhCong) {

            } else {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
};

export const layDuLieuThuNhapQuyetToan = async (nam: number) => {
    var rs: Array<DuLieuQuyetToanThueResponse> = [];
    await intance.post(ApiPaths.luong.layDuLieuQuyetToanThue + "?nam=" + nam)
        .then((res) => {
            if (res.data.trangThai === responseStatus.thanhCong) {
                rs = res.data.duLieu;
            } else {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
    return rs;
};

export const layDuLieuTinhThue = async (request: any) => {
    var rs: Array<ChiTietThueThangItem> = [];
    await intance.post(ApiPaths.luong.layDuLieuTinhThue, request)
        .then((res) => {
            if (res.data.trangThai === responseStatus.thanhCong) {
                rs = res.data.duLieu;
            } else {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
    return rs;
};

export const timKiemDsLuongHoanThanhNhiemVu = async (start: number, length: number, thangNam?: string) => {
    var rs: any = { data: [], recordsTotal: 0 };
    let formData = new FormData();
    formData.append("start", start.toString());
    formData.append("length", length.toString());
    if (thangNam) {
        formData.append("thangNam", thangNam);
    }
    await intance.post(ApiPaths.luong.timKiemDsLuongHoanThanhNhiemVu, formData, {
        headers: {
            "Content-Type": "multipart/form-data",
            "Accept": "application/json",
        },
    }).then((res) => {
        if (res.data.trangThai === responseStatus.thanhCong) {
            rs = res.data.duLieu;
        } else {
            throw new Error(res.data.thongBao);
        }
    }).catch((err) => {
        throw err;
    });
    return rs;
};

export const layDsLuongHoanThanhNhiemVuTheoNam = async (nam?: number) => {
    var rs: Array<any> = [];
    const qs = nam ? `?nam=${nam}` : '';
    await intance.get(ApiPaths.luong.layDsLuongHoanThanhNhiemVuTheoNam + qs).then((res) => {
        if (res.data.trangThai === responseStatus.thanhCong) {
            rs = res.data.duLieu;
        } else {
            throw new Error(res.data.thongBao);
        }
    }).catch((err) => {
        throw err;
    });
    return rs;
};

export const khoiTaoLuongHoanThanhNhiemVu = async (request: any) => {
    var rs = 0;
    await intance.post(ApiPaths.luong.khoiTaoLuongHoanThanhNhiemVu, request).then((res) => {
        if (res.data.trangThai === responseStatus.thanhCong) {
            rs = res.data.duLieu;
        } else {
            throw new Error(res.data.thongBao);
        }
    }).catch((err) => {
        throw err;
    });
    return rs;
};

export const layThongTinLuongHoanThanhNhiemVu = async (id: number) => {
    var rs: any = null;
    await intance.get(ApiPaths.luong.layThongTinLuongHoanThanhNhiemVu + "?id=" + id).then((res) => {
        if (res.data.trangThai === responseStatus.thanhCong) {
            rs = res.data.duLieu;
        } else {
            throw new Error(res.data.thongBao);
        }
    }).catch((err) => {
        throw err;
    });
    return rs;
};

export const taiDuLieuLuongHoanThanhNhiemVu = async (id: number) => {
    var rs: Array<any> = [];
    await intance.get(ApiPaths.luong.taiDuLieuLuongHoanThanhNhiemVu + "?id=" + id).then((res) => {
        if (res.data.trangThai === responseStatus.thanhCong) {
            rs = res.data.duLieu;
        } else {
            throw new Error(res.data.thongBao);
        }
    }).catch((err) => {
        throw err;
    });
    return rs;
};

export const chiTietLuongHoanThanhNhiemVu = async (id: number) => {
    var rs: Array<any> = [];
    await intance.get(ApiPaths.luong.chiTietLuongHoanThanhNhiemVu + "?id=" + id).then((res) => {
        if (res.data.trangThai === responseStatus.thanhCong) {
            rs = res.data.duLieu;
        } else {
            throw new Error(res.data.thongBao);
        }
    }).catch((err) => {
        throw err;
    });
    return rs;
};

export const luuLuongHoanThanhNhiemVu = async (request: any) => {
    await intance.post(ApiPaths.luong.luuLuongHoanThanhNhiemVu, request).then((res) => {
        if (res.data.trangThai !== responseStatus.thanhCong) {
            throw new Error(res.data.thongBao);
        }
    }).catch((err) => {
        throw err;
    });
};

export const duyetLuongHoanThanhNhiemVu = async (id: number) => {
    await intance.post(ApiPaths.luong.duyetLuongHoanThanhNhiemVu + "?id=" + id).then((res) => {
        if (res.data.trangThai !== responseStatus.thanhCong) {
            throw new Error(res.data.thongBao);
        }
    }).catch((err) => {
        throw err;
    });
};

export const luuDieuChinhChiTietLuongHoanThanhNhiemVu = async (request: any) => {
    await intance.post(ApiPaths.luong.luuDieuChinhChiTietLuongHoanThanhNhiemVu, request).then((res) => {
        if (res.data.trangThai !== responseStatus.thanhCong) {
            throw new Error(res.data.thongBao);
        }
    }).catch((err) => {
        throw err;
    });
};

export const xuatExcelLuongHoanThanhNhiemVu = async (id: number) => {
    var rs: any;
    await intance.get(ApiPaths.luong.xuatExcelLuongHoanThanhNhiemVu + "?id=" + id, { responseType: 'blob' })
        .then((res) => {
            rs = res;
        })
        .catch((err) => {
            throw 'Có lỗi xảy ra. Vui lòng thử lại';
        });
    return rs;
};

export const taiDuLieuTinhLuongBoSung = async (idNhomNhanSu: number, tongLuongDuocNhan: number, quyQuyetToan: number, namQuyetToan: number) => {
    var rs: Array<LuongBoSungResponse> = [];
    await intance.post(ApiPaths.luong.taiDuLieuTinhLuongBoSung, {
        "idNhomNhanSu": idNhomNhanSu,
        "quyQuyetToan": quyQuyetToan,
        "namQuyetToan": namQuyetToan,
        "tongLuongDuocNhan": tongLuongDuocNhan,
        }
    )
        .then((res) => {
            if (res.data.trangThai === responseStatus.thanhCong) {
                rs = res.data.duLieu;
            } else {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
    return rs;
};

export const khoaDieuChinhLuong = async (request: any) => {
    var rs = false;
    await intance.post(ApiPaths.luong.khoaDieuChinh, request).then((res) => {
        if (res.data.trangThai === responseStatus.thanhCong) {
            rs = true;
        } else {
            throw new Error(res.data.thongBao);
        }
    }).catch((err) => {
        throw err;
    });

    return rs;
};

export const layDuLieuNhanVienVaMucLuong_Cong_PhuCap = async (thang: number, nam: number) => {
    var rs: Array<NhanVien_MucLuong_PhuCap> = [];
    await intance.get(ApiPaths.luong.layDanhSachNhanVienMucLuongBHXHTrongThang + "?thang=" + thang + "&nam=" + nam).then((res) => {
        if (res.data.trangThai === responseStatus.thanhCong) {
            rs = res.data.duLieu;
        } else {
            throw new Error(res.data.thongBao);
        }
    }).catch((err) => {
        throw err;
    });

    return rs;
};

export const layDuLieuNhanVienVaMucLuong_Cong_PhuCapTheoIdNhanVien = async (thang: number, nam: number, idNhanVien: number) => {
    var rs = new NhanVien_MucLuong_PhuCap;
    await intance.get(ApiPaths.luong.layDLNhanVienMucLuongPhuCap + "TheoIdNhanVien" + "?thang=" + thang + "&nam=" + nam + "&idNhanVien=" + idNhanVien).then((res) => {
        if (res.data.trangThai === responseStatus.thanhCong) {
            rs = res.data.duLieu;
        } else {
            throw new Error(res.data.thongBao);
        }
    }).catch((err) => {
        throw err;
    });

    return rs;
};

export const luuKhenThuongUngHo = async (request: any) => {
    var rs = 0;
    await intance.post(ApiPaths.luong.luuKhenThuongUngHo, request).then((res) => {
        if (res.data.trangThai === responseStatus.thanhCong) {
            rs = res.data.duLieu
        } else {
            throw new Error(res.data.thongBao);
        }
    }).catch((err) => {
        throw err;
    });
    return rs;
};

export const layDsKhenThuongUngHo = async (thoiGian?: string) => {
    var rs: Array<DanhSachKhenThuongUngHoResponse> = [];
    await intance.get(ApiPaths.luong.layDsKhenThuongUngHo + "?thoiGian=" + thoiGian).then((res) => {
        if (res.data.trangThai === responseStatus.thanhCong) {
            rs = res.data.duLieu
        } else {
            throw new Error(res.data.thongBao);
        }
    }).catch((err) => {
        throw err;
    });
    return rs;
};

export const layChiTietKhenThuongUngHo = async (id: number) => {
    var rs: ChiTietKhenThuongUngHoResponse = new ChiTietKhenThuongUngHoResponse();
    await intance.get(ApiPaths.luong.layChiTietKhenThuongUngHo + "?idKTUH=" + id).then((res) => {
        if (res.data.trangThai === responseStatus.thanhCong) {
            rs = res.data.duLieu
        } else {
            throw new Error(res.data.thongBao);
        }
    }).catch((err) => {
        throw err;
    });
    return rs;
};

export const layDsTaiLieuLuongKhenThuongUngHo = async (id: number) => {
    var rs: Array<any> = [];
    await intance.get(ApiPaths.luong.layDsTaiLieuLuongKhenThuongUngHo + "?id=" + id).then((res) => {
        if (res.data.trangThai === responseStatus.thanhCong) {
            rs = res.data.duLieu || [];
        } else {
            throw new Error(res.data.thongBao);
        }
    }).catch((err) => {
        throw err;
    });
    return rs;
};

export const luuTaiLieuLuongKhenThuongUngHo = async (request: { idLuongKhenThuongUngHo: number, files?: any[], idsTaiLieuXoa?: number[] }) => {
    const formData = new FormData();
    formData.append("IdLuongKhenThuongUngHo", request.idLuongKhenThuongUngHo.toString());
    if (request.files && request.files.length > 0) {
        request.files.forEach((file: any) => {
            formData.append("Files", file);
        });
    }
    if (request.idsTaiLieuXoa && request.idsTaiLieuXoa.length > 0) {
        request.idsTaiLieuXoa.forEach((id: number) => {
            formData.append("IdsTaiLieuXoa", id.toString());
        });
    }
    await intance.post(ApiPaths.luong.luuTaiLieuLuongKhenThuongUngHo, formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    }).then((res) => {
        if (res.data.trangThai !== responseStatus.thanhCong) {
            throw new Error(res.data.thongBao);
        }
    }).catch((err) => {
        throw err;
    });
};

export const luuPhatSinhTinhThue = async (request: any) => {
    var rs = 0;
    await intance.post(ApiPaths.luong.luuPhatSinhTinhThue, request).then((res) => {
        if (res.data.trangThai === responseStatus.thanhCong) {
            rs = res.data.duLieu
        } else {
            throw new Error(res.data.thongBao);
        }
    }).catch((err) => {
        throw err;
    });
    return rs;
};

export const layDsPhatSinhTinhThue = async (thoiGian?: string) => {
    var rs: Array<DanhSachKhenThuongUngHoResponse> = [];
    await intance.get(ApiPaths.luong.layDsPhatSinhTinhThue + "?thoiGian=" + thoiGian).then((res) => {
        if (res.data.trangThai === responseStatus.thanhCong) {
            rs = res.data.duLieu
        } else {
            throw new Error(res.data.thongBao);
        }
    }).catch((err) => {
        throw err;
    });
    return rs;
};

export const layChiTietPhatSinhTinhThue = async (id: number) => {
    var rs: ChiTietPhatSinhTinhThueResponse = new ChiTietPhatSinhTinhThueResponse();
    await intance.get(ApiPaths.luong.layChiTietPhatSinhTinhThue + "?idPSTT=" + id).then((res) => {
        if (res.data.trangThai === responseStatus.thanhCong) {
            rs = res.data.duLieu
        } else {
            throw new Error(res.data.thongBao);
        }
    }).catch((err) => {
        throw err;
    });
    return rs;
};

export const taiDuLieuLuongBoSungNguoiLD = async (request: any) => {
    var rs: Array<LuongBoSungNLDResponse> = [];
    await intance.post(ApiPaths.luong.taiDuLieuLuongBoSungNguoiLD, request).then((res) => {
        if (res.data.trangThai === responseStatus.thanhCong) {
            rs = res.data.duLieu;
        } else {
            throw new Error(res.data.thongBao);
        }
    }).catch((err) => {
        throw err;
    });

    return rs;
};

export const layDsLuongBoSung = async () => {
    var rs: Array<DanhSachLuongBoSungResponse> = [];
    await intance.get(ApiPaths.luong.layDsLuongBoSung).then((res) => {
        if (res.data.trangThai === responseStatus.thanhCong) {
            rs = res.data.duLieu;
        } else {
            throw new Error(res.data.thongBao);
        }
    }).catch((err) => {
        throw 'Có lỗi xảy ra. Vui lòng thử lại';
    });

    return rs;
};

export const layChiTietLuongQuyetToan = async (id: number) => {
    var rs: ChiTietLuongBoSungResponse = new ChiTietLuongBoSungResponse;
    await intance.get(`${ApiPaths.luong.layChiTietLuongBoSung}?idLQT=${id}`).then((res) => {
        if (res.data.trangThai === responseStatus.thanhCong) {
            rs = res.data.duLieu;
        } else {
            throw new Error(res.data.thongBao);
        }
    }).catch((err) => {
        throw 'Có lỗi xảy ra. Vui lòng thử lại';
    });

    return rs;
};

export const taiDieuChinhLuongBoSungNLD = async (request: any) => {
    var rs: Array<LuongBoSungNLDResponse> = [];
    await intance.post(ApiPaths.luong.layDuLieuDieuChinhLuongBoSungNguoiLD, request).then((res) => {
        if (res.data.trangThai === responseStatus.thanhCong) {
            rs = res.data.duLieu;
        } else {
            throw new Error(res.data.thongBao);
        }
    }).catch((err) => {
        throw err;
    });

    return rs;
};

export const luuDieuChinhLuongBoSungNLD = async (request: any) => {
    var rs = 0;
    await intance.post(ApiPaths.luong.luuDieuChinhLuongBoSungNLD, request).then((res) => {
        if (res.data.trangThai === responseStatus.thanhCong) {
            rs = res.data.duLieu;
        } else {
            throw new Error(res.data.thongBao);
        }
    }).catch((err) => {
        throw err;
    });

    return rs;
};

export const taiDuLieuLuongBoSungNLDTheoNam = async (request: any) => {
    var rs: Array<LuongBoSungNLDResponse> = [];
    await intance.post(ApiPaths.luong.taiDuLieuTinhLuongBoSungNLDTheoNam, request).then((res) => {
        if (res.data.trangThai === responseStatus.thanhCong) {
            rs = res.data.duLieu;
        } else {
            throw new Error(res.data.thongBao);
        }
    }).catch((err) => {
        throw err;
    });

    return rs;
}
export const layDsLuongBoSungNQL = async () => {
    var rs: Array<any> = [];
    await intance.get(ApiPaths.luong.layDsLuongBoSungNQL).then((res) => {
        if (res.data.trangThai === responseStatus.thanhCong) {
            rs = res.data.duLieu;
        } else {
            throw new Error(res.data.thongBao);
        }
    }).catch((err) => {
        throw 'Có lỗi xảy ra. Vui lòng thử lại';
    });

    return rs;
}

export const trinhLuongBoSungNQL = async (id: any) => {
    await intance.post(ApiPaths.luong.trinhLuongBoSungNQL + "?id=" + id).then((res) => {
        if (res.data.trangThai === responseStatus.thanhCong) {
        } else {
            throw new Error(res.data.thongBao);
        }
    }).catch((err) => {
        throw 'Có lỗi xảy ra. Vui lòng thử lại';
    });
}

export const duyetLuongBoSungNQL = async (id: any) => {
    await intance.post(ApiPaths.luong.duyetLuongBoSungNQL + "?id=" + id).then((res) => {
        if (res.data.trangThai === responseStatus.thanhCong) {
        } else {
            throw new Error(res.data.thongBao);
        }
    }).catch((err) => {
        throw 'Có lỗi xảy ra. Vui lòng thử lại';
    });
}

export const trinhLuongQuyetToanNLD = async (id: any) => {
    await intance.post(ApiPaths.luong.trinhLuongQuyetToanNLD + "?id=" + id).then((res) => {
        if (res.data.trangThai === responseStatus.thanhCong) {
        } else {
            throw new Error(res.data.thongBao);
        }
    }).catch((err) => {
        throw 'Có lỗi xảy ra. Vui lòng thử lại';
    });
}

export const duyetLuongQuyetToanNLD = async (id: any) => {
    await intance.post(ApiPaths.luong.duyetLuongQuyetToanNLD + "?id=" + id).then((res) => {
        if (res.data.trangThai === responseStatus.thanhCong) {
        } else {
            throw new Error(res.data.thongBao);
        }
    }).catch((err) => {
        throw 'Có lỗi xảy ra. Vui lòng thử lại';
    });
}

export const luuLuongBoSungNQL = async (request: any) => {
    var rs: any;
    await intance.post(ApiPaths.luong.luuLuongBoSungNQL, request).then((res) => {
        if (res.data.trangThai === responseStatus.thanhCong) {
            rs = res.data.duLieu;
        } else {
            throw new Error(res.data.thongBao);
        }
    }).catch((err) => {
        throw 'Có lỗi xảy ra. Vui lòng thử lại';
    });

    return rs;
}

export const layLuongBoSungNQL = async (id: any) => {
    var rs: any;
    await intance.get(ApiPaths.luong.layLuongBoSungNQL + "?id=" + id).then((res) => {
        if (res.data.trangThai === responseStatus.thanhCong) {
            rs = res.data.duLieu;
        } else {
            throw new Error(res.data.thongBao);
        }
    }).catch((err) => {
        throw 'Có lỗi xảy ra. Vui lòng thử lại';
    });

    return rs;
}

export const xoaLuongBoSungNQL = async (id: any) => {
    await intance.post(ApiPaths.luong.xoaLuongBoSungNQL + "?id=" + id).then((res) => {
        if (res.data.trangThai === responseStatus.thanhCong) {
        } else {
            throw new Error(res.data.thongBao);
        }
    }).catch((err) => {
        throw 'Có lỗi xảy ra. Vui lòng thử lại';
    });
}

export const xoaLuongQuyetToanNLD = async (id: any) => {
    await intance.post(ApiPaths.luong.xoaLuongQuyetToanNLD + "?id=" + id).then((res) => {
        if (res.data.trangThai === responseStatus.thanhCong) {
        } else {
            throw new Error(res.data.thongBao);
        }
    }).catch((err) => {
        throw 'Có lỗi xảy ra. Vui lòng thử lại';
    });
}

export const tinhLuongBoSungNQL = async (id: any) => {
    var rs: any;
    await intance.post(ApiPaths.luong.tinhLuongBoSungNQL + "?id=" + id).then((res) => {
        if (res.data.trangThai === responseStatus.thanhCong) {
            rs = res.data.duLieu;
        } else {
            throw new Error(res.data.thongBao);
        }
    }).catch((err) => {
        throw 'Có lỗi xảy ra. Vui lòng thử lại';
    });

    return rs;
}

export const layDsPhuCapTGV = async () => {
    var rs: Array<PhuCapTGV> = [];
    await intance.get(ApiPaths.luong.layDsPhuCapTGV).then((res) => {
        if (res.data.trangThai === responseStatus.thanhCong) {
            rs = res.data.duLieu;
        } else {
            throw new Error(res.data.thongBao);
        }
    }).catch((err) => {
        throw 'Có lỗi xảy ra. Vui lòng thử lại';
    });

    return rs;
};

export const layDsPhuCapTGVTheoNam = async (nam?: number) => {
    let url = ApiPaths.luong.layDsPhuCapTGVTheoNam;
    if (nam) {
        url += `?nam=${nam}`;
    }
    let rs: any[] = [];
    await intance.get(url)
        .then((res) => {
            if (res.data.trangThai === responseStatus.thanhCong) rs = res.data.duLieu;
            else throw Error(res.data.thongBao);
        })
        .catch((err) => { throw err; });
    return rs;
};

export const tinhPhuCapToGiupViec = async (request: any) => {
    var rs: Array<any> = [];
    await intance.post(ApiPaths.luong.tinhPhuCapTGV, request).then((res) => {
        if (res.data.trangThai === responseStatus.thanhCong) {
            rs = res.data.duLieu;
        } else {
            throw new Error(res.data.thongBao);
        }
    }).catch((err) => {
        throw err;
    });

    return rs;
}

export const luuPhuCapToGiupViec = async (request: any) => {
    var rs: any;
    await intance.post(ApiPaths.luong.luuPhuCapTGV, request).then((res) => {
        if (res.data.trangThai === responseStatus.thanhCong) {
            rs = res.data.duLieu;
        } else {
            throw new Error(res.data.thongBao);
        }
    }).catch((err) => {
        throw 'Có lỗi xảy ra. Vui lòng thử lại';
    });

    return rs;
}

export const layChiTietPhuCapToGiupViec = async (id: number) => {
    var rs: Array<PhuCapTGV> = [];
    await intance.get(`${ApiPaths.luong.layChiTietPhuCapTGV}?id=${id}`).then((res) => {
        if (res.data.trangThai === responseStatus.thanhCong) {
            rs = res.data.duLieu;
        } else {
            throw new Error(res.data.thongBao);
        }
    }).catch((err) => {
        throw 'Có lỗi xảy ra. Vui lòng thử lại';
    });

    return rs;
}

export const trinhLuongPhuCapToGiaoViec = async (id: any) => {
    await intance.post(ApiPaths.luong.trinhLuongPhuCapToGiaoViec + "?id=" + id).then((res) => {
        if (res.data.trangThai === responseStatus.thanhCong) {
        } else {
            throw new Error(res.data.thongBao);
        }
    }).catch((err) => {
        throw 'Có lỗi xảy ra. Vui lòng thử lại';
    });
}

export const duyetLuongPhuCapToGiaoViec = async (id: any) => {
    await intance.post(ApiPaths.luong.duyetLuongPhuCapToGiaoViec + "?id=" + id).then((res) => {
        if (res.data.trangThai === responseStatus.thanhCong) {
        } else {
            throw new Error(res.data.thongBao);
        }
    }).catch((err) => {
        throw 'Có lỗi xảy ra. Vui lòng thử lại';
    });
}

export const xacNhanLuongPhuCapToGiaoViec = async (id: any) => {
    await intance.post(ApiPaths.luong.xacNhanLuongPhuCapToGiaoViec + "?id=" + id).then((res) => {
        if (res.data.trangThai === responseStatus.thanhCong) {
        } else {
            throw new Error(res.data.thongBao);
        }
    }).catch((err) => {
        throw 'Có lỗi xảy ra. Vui lòng thử lại';
    });
}

export const xoaLuongPhuCapToGiaoViec = async (id: any) => {
    await intance.post(ApiPaths.luong.xoaLuongPhuCapToGiaoViec + "?id=" + id).then((res) => {
        if (res.data.trangThai === responseStatus.thanhCong) {
        } else {
            throw new Error(res.data.thongBao);
        }
    }).catch((err) => {
        throw 'Có lỗi xảy ra. Vui lòng thử lại';
    });
}

export const layDsOptionsCauHinhLuong = async (thang: any, nam: any, loai: number) => {
    var rs = new DsOptionsLuongThanhPhan();    
    await intance.get(ApiPaths.luong.layDsOptionCauHinhThanhPhan + "?thang=" + thang + "&nam=" + nam + "&loai=" + loai).then((res) => {
        if (res.data.trangThai === responseStatus.thanhCong) {
            rs = res.data.duLieu;
        } else {
            throw new Error(res.data.thongBao);
        }
    }).catch((err) => {
        throw 'Có lỗi xảy ra. Vui lòng thử lại';
    });

    return rs;
}

export const luuChiTietLuongThang = async (request: ChiTietLuongThanhPhan) => {
    var rs: any;
    await intance.post(ApiPaths.luong.luuChiTietLuongThanhPhan, request).then((res) => {
        if (res.data.trangThai === responseStatus.thanhCong) {
            rs = res.data.duLieu;
        } else {
            throw new Error(res.data.thongBao);
        }
    }).catch((err) => {
        throw 'Có lỗi xảy ra. Vui lòng thử lại';
    });

    return rs;
}

export const xoaLuongKhenThuongUngHo = async (id: any) => {
    await intance.post(ApiPaths.luong.xoaLuongKhenThuongUngHo + "?id=" + id).then((res) => {
        if (res.data.trangThai === responseStatus.thanhCong) {
        } else {
            throw new Error(res.data.thongBao);
        }
    }).catch((err) => {
        throw 'Có lỗi xảy ra. Vui lòng thử lại';
    });
}

export const xoaPhatSinhTinhThue = async (id: any) => {
    await intance.post(ApiPaths.luong.xoaPhatSinhTinhThue + "?id=" + id).then((res) => {
        if (res.data.trangThai === responseStatus.thanhCong) {
        } else {
            throw new Error(res.data.thongBao);
        }
    }).catch((err) => {
        throw 'Có lỗi xảy ra. Vui lòng thử lại';
    });
}

export const layMauLuongPhatSinh = async (thang: number, nam: number) => {
    var rs: any;
    var request = {
        "thang": thang,
        "nam": nam
    }
    await intance.post(ApiPaths.luong.layMauFileLuongPhatSinh, request, { responseType: 'blob' })
        .then((res) => {
            rs = res;
        })
        .catch((err) => {
            throw 'Có lỗi xảy ra. Vui lòng thử lại';
        });
    return rs;
};

export const importFileLuongPhatSinh = async (request: ImportFileLPS) => {
    var rs: Array<NhanVien_MucLuong_PhuCap> = new Array<NhanVien_MucLuong_PhuCap>();
    await intance.post(ApiPaths.luong.importFileLPS,
        request,
        {
            headers: {
                "Content-Type": "multipart/form-data",
                "Accept": "application/json",
            },
        }
    )
        .then((res) => {
            if (res.data.trangThai === responseStatus.thanhCong) {
                rs = res.data.duLieu;
            } else {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw 'Có lỗi xảy ra. Vui lòng thử lại';
        });
    return rs;
};

export const importFileCongDoanPhi = async (file: File, thoiGian?: string) => {
    var rs: Array<NhanVien_MucLuong_PhuCap> = new Array<NhanVien_MucLuong_PhuCap>();
    const formData = new FormData();
    formData.append("File", file);
    if (thoiGian) {
        formData.append("ThoiGian", thoiGian);
    }
    await intance.post(ApiPaths.luong.importFileCongDoanPhi,
        formData,
        {
            headers: {
                "Content-Type": "multipart/form-data",
                "Accept": "application/json",
            },
        }
    )
        .then((res) => {
            if (res.data.trangThai === responseStatus.thanhCong) {
                rs = res.data.duLieu;
            } else {
                throw new Error(res.data.thongBao || "Không thể import file công đoàn phí");
            }
        })
        .catch((err) => {
            throw err?.message || err || "Không thể import file công đoàn phí";
        });
    return rs;
};

export const XuatExcelLuongPhatSinh = async (id: number) => {
    var rs: any;
    await intance.get(ApiPaths.luong.xuatExcelLuongPhatSinh + "?id=" + id, { responseType: 'blob' })
        .then((res) => {
            rs = res;
        })
        .catch((err) => {
            throw 'Có lỗi xảy ra. Vui lòng thử lại';
        });
    return rs;
}

export const importFilePhatSinhTinhThue = async (request: ImportFileLPS) => {
    var rs: ChiTietPhatSinhTinhThueResponse = new ChiTietPhatSinhTinhThueResponse();
    await intance.post(ApiPaths.luong.importFilePhatSinhTinhThue,
        request,
        {
            headers: {
                "Content-Type": "multipart/form-data",
                "Accept": "application/json",
            },
        }
    )
        .then((res) => {
            if (res.data.trangThai === responseStatus.thanhCong) {
                rs = res.data.duLieu;
            } else {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw 'Có lỗi xảy ra. Vui lòng thử lại';
        });
    return rs;
};

export const xuatExcelPhatSinhTinhThue = async (id: number) => {
    var rs: any;
    await intance.get(ApiPaths.luong.xuatExcelPhatSinhTinhThue + "?id=" + id, { responseType: 'blob' })
        .then((res) => {
            rs = res;
        })
        .catch((err) => {
            throw 'Có lỗi xảy ra. Vui lòng thử lại';
        });
    return rs;
};
export const xuatExcelPhuCapToGiupViec = async (id: number) => {
    var rs: any;
    await intance.get(ApiPaths.luong.xuatExcelPhuCapToGiupViec + "?id=" + id, { responseType: 'blob' })
        .then((res) => {
            rs = res;
        })
        .catch((err) => {
            throw 'Có lỗi xảy ra. Vui lòng thử lại';
        });
    return rs;
};

// Lấy danh sách lương cơ bản (tạm ứng cơ bản)
export const layDsLuongCoBan = async (start: number, length: number, thangNam?: string, loai?: number) => {
    var rs: any = {
        data: [],
        recordsTotal: 0,
    };
    var qs = `?start=${start}&length=${length}`;
    if (thangNam) qs += `&thangNam=${thangNam}`;
    if (loai !== undefined && loai !== null) qs += `&loai=${loai}`;
    await intance.get(ApiPaths.luong.layDsLuongCoBan + qs)
        .then((res) => {
            if (res.data.trangThai == responseStatus.thanhCong) {
                rs = res.data.duLieu;
            } else {
                throw Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
    return rs;
};

// Khởi tạo lương cơ bản
export const khoiTaoLuongCoBan = async (request: {
    thangNam: string,
    loai: number,
    idLuongTamUng?: number | null,
    isTruCongDoan: boolean,
    dsIdBaoHiemThang: number[],
    dsIdLuongKhenThuongUngHo: number[]
}) => {
    var rs: any = null;
    await intance.post(ApiPaths.luong.khoiTaoLuongCoBan, request)
        .then((res) => {
            if (res.data.trangThai == responseStatus.thanhCong) {
                rs = res.data.duLieu;
            } else {
                throw Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
    return rs;
};

// Lấy danh sách lương khen thưởng/ủng hộ theo năm (dùng cho modal chọn khoản giảm trừ)
export const layDsKhenThuongUngHoTheoNam = async (nam?: number) => {
    var rs: Array<DanhSachKhenThuongUngHoResponse> = [];
    const qs = nam ? `?nam=${nam}` : '';
    await intance.get(ApiPaths.luong.layDsKhenThuongUngHoTheoNam + qs)
        .then((res) => {
            if (res.data.trangThai == responseStatus.thanhCong) {
                rs = res.data.duLieu;
            } else {
                throw Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
    return rs;
};

export const layDsPhatSinhTinhThueTheoNam = async (nam?: number) => {
    var rs: Array<DanhSachKhenThuongUngHoResponse> = [];
    const qs = nam ? `?nam=${nam}` : '';
    await intance.get(ApiPaths.luong.layDsPhatSinhTinhThueTheoNam + qs)
        .then((res) => {
            if (res.data.trangThai == responseStatus.thanhCong) {
                rs = res.data.duLieu;
            } else {
                throw Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
    return rs;
};

// Lấy danh sách lương cơ bản tạm ứng theo năm (dùng cho modal chọn khoản khấu trừ khi điều chỉnh)
export const layDsLuongCoBanTamUngTheoNam = async (nam?: number) => {
    var rs: Array<any> = [];
    const qs = nam ? `?nam=${nam}` : '';
    await intance.get(ApiPaths.luong.layDsLuongCoBanTamUngTheoNam + qs)
        .then((res) => {
            if (res.data.trangThai == responseStatus.thanhCong) {
                rs = res.data.duLieu;
            } else {
                throw Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
    return rs;
};

// Lấy thông tin chung lương cơ bản
export const layThongTinLuongCoBan = async (id: number) => {
    var rs: any = null;
    await intance.get(ApiPaths.luong.layThongTinLuongCoBan + '?id=' + id)
        .then((res) => {
            if (res.data.trangThai == responseStatus.thanhCong) {
                rs = res.data.duLieu;
            } else {
                throw Error(res.data.thongBao);
            }
        })
        .catch((err) => { throw err; });
    return rs;
};

// Tính/tải chi tiết lương cơ bản
export const taiLuongCoBan = async (id: number) => {
    var rs: Array<any> = [];
    await intance.get(ApiPaths.luong.taiLuongCoBan + '?id=' + id)
        .then((res) => {
            if (res.data.trangThai == responseStatus.thanhCong) {
                rs = res.data.duLieu;
            } else {
                throw Error(res.data.thongBao);
            }
        })
        .catch((err) => { throw err; });
    return rs;
};

// Lấy chi tiết lương cơ bản đã lưu
export const layChiTietLuongCoBan = async (id: number) => {
    var rs: Array<any> = [];
    await intance.get(ApiPaths.luong.layChiTietLuongCoBan + '?id=' + id)
        .then((res) => {
            if (res.data.trangThai == responseStatus.thanhCong) {
                rs = res.data.duLieu;
            } else {
                throw Error(res.data.thongBao);
            }
        })
        .catch((err) => { throw err; });
    return rs;
};

// Lưu chi tiết lương cơ bản
export const luuLuongCoBan = async (request: { id: number; chiTiet: any[] }) => {
    await intance.post(ApiPaths.luong.luuLuongCoBan, request)
        .then((res) => {
            if (res.data.trangThai !== responseStatus.thanhCong) {
                throw Error(res.data.thongBao);
            }
        })
        .catch((err) => { throw err; });
};

// Duyệt lương cơ bản
export const duyetLuongCoBan = async (id: number) => {
    await intance.post(ApiPaths.luong.duyetLuongCoBan + '?id=' + id)
        .then((res) => {
            if (res.data.trangThai !== responseStatus.thanhCong) {
                throw Error(res.data.thongBao);
            }
        })
        .catch((err) => { throw err; });
};

// Cập nhật dữ liệu tham chiếu lương cơ bản
export const capNhatDuLieuThamChieuLuongCoBan = async (request: any) => {
    await intance.post(ApiPaths.luong.capNhatDuLieuThamChieuLuongCoBan, request)
        .then((res) => {
            if (res.data.trangThai !== responseStatus.thanhCong) {
                throw Error(res.data.thongBao);
            }
        })
        .catch((err) => { throw err; });
};

// Lưu điều chỉnh chi tiết lương cơ bản
export const luuDieuChinhChiTietLuong = async (request: any) => {
    await intance.post(ApiPaths.luong.luuDieuChinhChiTietLuong, request)
        .then((res) => {
            if (res.data.trangThai !== responseStatus.thanhCong) {
                throw Error(res.data.thongBao);
            }
        })
        .catch((err) => { throw err; });
};

export const importFileLuongCoBan = async (idLuongCoBan: number, file: File, xacNhanTaoDanhMuc: boolean = false) => {
    var rs: any;
    const formData = new FormData();
    formData.append('idLuongCoBan', idLuongCoBan.toString());
    formData.append('file', file);
    formData.append('xacNhanTaoDanhMuc', xacNhanTaoDanhMuc ? 'true' : 'false');
    await intance.post(ApiPaths.luong.importFileLuongCoBan, formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    })
        .then((res) => {
            if (res.data.trangThai == responseStatus.thanhCong) {
                rs = res.data.duLieu;
            } else {
                throw Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
    return rs;
};

export const xuatExcelLuongCoBan = async (id: number) => {
    var rs: any;
    await intance.get(ApiPaths.luong.xuatExcelLuongCoBan + "?id=" + id, { responseType: 'blob' })
        .then((res) => {
            rs = res;
        })
        .catch((err) => {
            throw 'Có lỗi xảy ra. Vui lòng thử lại';
        });
    return rs;
};

// --- LƯƠNG PHỤ CẤP ---
export const timKiemDsBangLuongPhuCap = async (data: any) => {
    let rs: any;
    let formData = new FormData();
    formData.append("start", data.start);
    formData.append("length", data.length);
    if (data.thangNam) {
        formData.append("thangNam", data.thangNam);
    }
    if (data.loai || data.loai === 0) {
        formData.append("loai", data.loai);
    }
    await intance.post(ApiPaths.luong.timKiemDsBangLuongPhuCap, formData, {
        headers: {
            "Content-Type": "multipart/form-data",
            "Accept": "application/json",
        },
    }).then((res) => {
        if (res.data.trangThai === responseStatus.thanhCong) rs = res.data.duLieu;
        else throw Error(res.data.thongBao);
    }).catch((err) => { throw err; });
    return rs;
};

export const layDsBangLuongPhuCapTamUngTheoNam = async (nam: number | null) => {
    let url = ApiPaths.luong.layDsBangLuongPhuCapTamUngTheoNam;
    if (nam) url += `?nam=${nam}`;
    let rs: any[] = [];
    await intance.get(url)
        .then((res) => {
            if (res.data.trangThai === responseStatus.thanhCong) rs = res.data.duLieu;
            else throw Error(res.data.thongBao);
        })
        .catch((err) => { throw err; });
    return rs;
};

export const layDsBangLuongPhuCapTheoNam = async (nam?: number) => {
    let url = ApiPaths.luong.layDsBangLuongPhuCapTheoNam;
    if (nam) {
        url += `?nam=${nam}`;
    }
    let rs: any[] = [];
    await intance.get(url)
        .then((res) => {
            if (res.data.trangThai === responseStatus.thanhCong) rs = res.data.duLieu;
            else throw Error(res.data.thongBao);
        })
        .catch((err) => { throw err; });
    return rs;
};

export const khoiTaoBangLuongPhuCap = async (request: any) => {
    let rs = 0;
    await intance.post(ApiPaths.luong.khoiTaoBangLuongPhuCap, request)
        .then((res) => {
            if (res.data.trangThai === responseStatus.thanhCong) rs = res.data.duLieu;
            else throw Error(res.data.thongBao);
        })
        .catch((err) => { throw err; });
    return rs;
};

export const layThongTinBangLuongPhuCap = async (id: number) => {
    let rs: any = null;
    await intance.get(ApiPaths.luong.layThongTinBangLuongPhuCap + '?id=' + id)
        .then((res) => {
            if (res.data.trangThai === responseStatus.thanhCong) rs = res.data.duLieu;
            else throw Error(res.data.thongBao);
        })
        .catch((err) => { throw err; });
    return rs;
};

export const taiDuLieuLuongPhuCap = async (id: number) => {
    let rs: any[] = [];
    await intance.get(ApiPaths.luong.taiDuLieuLuongPhuCap + '?id=' + id)
        .then((res) => {
            if (res.data.trangThai === responseStatus.thanhCong) rs = res.data.duLieu;
            else throw Error(res.data.thongBao);
        })
        .catch((err) => { throw err; });
    return rs;
};

export const chiTietLuongPhuCap = async (id: number) => {
    let rs: any[] = [];
    await intance.get(ApiPaths.luong.chiTietLuongPhuCap + '?id=' + id)
        .then((res) => {
            if (res.data.trangThai === responseStatus.thanhCong) rs = res.data.duLieu;
            else throw Error(res.data.thongBao);
        })
        .catch((err) => { throw err; });
    return rs;
};

export const luuLuongPhuCap = async (request: any) => {
    await intance.post(ApiPaths.luong.luuLuongPhuCap, request)
        .then((res) => {
            if (res.data.trangThai !== responseStatus.thanhCong) throw Error(res.data.thongBao);
        })
        .catch((err) => { throw err; });
};

export const duyetLuongPhuCap = async (id: number) => {
    await intance.post(ApiPaths.luong.duyetLuongPhuCap + '?id=' + id)
        .then((res) => {
            if (res.data.trangThai !== responseStatus.thanhCong) throw Error(res.data.thongBao);
        })
        .catch((err) => { throw err; });
};

export const luuDieuChinhChiTietLuongPhuCap = async (request: any) => {
    await intance.post(ApiPaths.luong.luuDieuChinhChiTietLuongPhuCap, request)
        .then((res) => {
            if (res.data.trangThai !== responseStatus.thanhCong) throw Error(res.data.thongBao);
        })
        .catch((err) => { throw err; });
};

export const importFileLuongPhuCap = async (idBangLuongPhuCap: number, file: File) => {
    let formData = new FormData();
    formData.append("IdBangLuongPhuCap", idBangLuongPhuCap.toString());
    formData.append("File", file);

    let rs: any[] = [];
    await intance.post(ApiPaths.luong.importFileLuongPhuCap, formData, {
        headers: {
            "Content-Type": "multipart/form-data",
            "Accept": "application/json",
        },
    }).then((res) => {
        if (res.data.trangThai === responseStatus.thanhCong) rs = res.data.duLieu;
        else throw Error(res.data.thongBao);
    }).catch((err) => { throw err; });
    return rs;
};

export const xuatExcelLuongPhuCap = async (id: number) => {
    var rs: any;
    await intance.get(ApiPaths.luong.xuatExcelLuongPhuCap + "?id=" + id, { responseType: 'blob' })
        .then((res) => {
            rs = res;
        })
        .catch((err) => {
            throw 'Có lỗi xảy ra. Vui lòng thử lại';
        });
    return rs;
};

// Cập nhật dữ liệu quỹ lương hoàn thành nhiệm vụ
export const capNhatQuyLuongHoanThanhNhiemVu = async (request: any) => {
    await intance.post(ApiPaths.luong.capNhatQuyLuongHoanThanhNhiemVu, request)
        .then((res) => {
            if (res.data.trangThai !== responseStatus.thanhCong) {
                throw Error(res.data.thongBao);
            }
        })
        .catch((err) => { throw err; });
};

// Cập nhật các tháng lấy dữ liệu quyết toán lương hoàn thành nhiệm vụ
export const capNhatThangLayDuLieuHoanThanhNhiemVu = async (request: any) => {
    await intance.post(ApiPaths.luong.capNhatThangLayDuLieuHoanThanhNhiemVu, request)
        .then((res) => {
            if (res.data.trangThai !== responseStatus.thanhCong) {
                throw Error(res.data.thongBao);
            }
        })
        .catch((err) => { throw err; });
};

// Lương bổ sung trưởng BKS
export const timKiemDsLuongBoSungTruongBKS = async (start: number, length: number, thangNam?: string) => {
    var rs: any = { data: [], recordsTotal: 0 };
    let formData = new FormData();
    formData.append("start", start.toString());
    formData.append("length", length.toString());
    if (thangNam) {
        formData.append("thangNam", thangNam);
    }
    await intance.post(ApiPaths.luong.timKiemDsLuongBoSungTruongBKS, formData, {
        headers: {
            "Content-Type": "multipart/form-data",
            "Accept": "application/json",
        },
    }).then((res) => {
        if (res.data.trangThai === responseStatus.thanhCong) {
            rs = res.data.duLieu;
        } else {
            throw new Error(res.data.thongBao);
        }
    }).catch((err) => {
        throw err;
    });
    return rs;
};

export const layDsLuongCoBanChoLuongBSTBKS = async (nam?: number) => {
    var rs: Array<any> = [];
    await intance.get(ApiPaths.luong.layDsLuongCoBanChoLuongBSTBKS + (nam ? "?nam=" + nam : "")).then((res) => {
        if (res.data.trangThai === responseStatus.thanhCong) {
            rs = res.data.duLieu;
        } else {
            throw new Error(res.data.thongBao);
        }
    }).catch((err) => {
        throw err;
    });
    return rs;
};

export const layDsLuongBoSungTruongBKSTheoNam = async (nam?: number) => {
    var rs: Array<any> = [];
    await intance.get(ApiPaths.luong.layDsLuongBoSungTruongBKSTheoNam + (nam ? "?nam=" + nam : "")).then((res) => {
        if (res.data.trangThai === responseStatus.thanhCong) {
            rs = res.data.duLieu;
        } else {
            throw new Error(res.data.thongBao);
        }
    }).catch((err) => {
        throw err;
    });
    return rs;
};

export const khoiTaoLuongBoSungTruongBKS = async (request: any) => {
    var rs = 0;
    await intance.post(ApiPaths.luong.khoiTaoLuongBoSungTruongBKS, request).then((res) => {
        if (res.data.trangThai === responseStatus.thanhCong) {
            rs = res.data.duLieu;
        } else {
            throw new Error(res.data.thongBao);
        }
    }).catch((err) => {
        throw err;
    });
    return rs;
};

export const layThongTinLuongBoSungTruongBKS = async (id: number) => {
    var rs: any = null;
    await intance.get(ApiPaths.luong.layThongTinLuongBoSungTruongBKS + "?id=" + id).then((res) => {
        if (res.data.trangThai === responseStatus.thanhCong) {
            rs = res.data.duLieu;
        } else {
            throw new Error(res.data.thongBao);
        }
    }).catch((err) => {
        throw err;
    });
    return rs;
};

export const taiDuLieuLuongBoSungTruongBKS = async (id: number) => {
    var rs: Array<any> = [];
    await intance.get(ApiPaths.luong.taiDuLieuLuongBoSungTruongBKS + "?id=" + id).then((res) => {
        if (res.data.trangThai === responseStatus.thanhCong) {
            rs = res.data.duLieu;
        } else {
            throw new Error(res.data.thongBao);
        }
    }).catch((err) => {
        throw err;
    });
    return rs;
};

export const chiTietLuongBoSungTruongBKS = async (id: number) => {
    var rs: Array<any> = [];
    await intance.get(ApiPaths.luong.chiTietLuongBoSungTruongBKS + "?id=" + id).then((res) => {
        if (res.data.trangThai === responseStatus.thanhCong) {
            rs = res.data.duLieu;
        } else {
            throw new Error(res.data.thongBao);
        }
    }).catch((err) => {
        throw err;
    });
    return rs;
};

export const luuLuongBoSungTruongBKS = async (request: any) => {
    await intance.post(ApiPaths.luong.luuLuongBoSungTruongBKS, request).then((res) => {
        if (res.data.trangThai !== responseStatus.thanhCong) {
            throw new Error(res.data.thongBao);
        }
    }).catch((err) => {
        throw err;
    });
};

export const duyetLuongBoSungTruongBKS = async (id: number) => {
    await intance.post(ApiPaths.luong.duyetLuongBoSungTruongBKS + "?id=" + id).then((res) => {
        if (res.data.trangThai !== responseStatus.thanhCong) {
            throw new Error(res.data.thongBao);
        }
    }).catch((err) => {
        throw err;
    });
};

export const luuDieuChinhChiTietLuongBoSungTruongBKS = async (request: any) => {
    await intance.post(ApiPaths.luong.luuDieuChinhChiTietLuongBoSungTruongBKS, request).then((res) => {
        if (res.data.trangThai !== responseStatus.thanhCong) {
            throw new Error(res.data.thongBao);
        }
    }).catch((err) => {
        throw err;
    });
};

export const capNhatQuyLuongBoSungTruongBKS = async (request: any) => {
    await intance.post(ApiPaths.luong.capNhatQuyLuongBoSungTruongBKS, request)
        .then((res) => {
            if (res.data.trangThai !== responseStatus.thanhCong) {
                throw Error(res.data.thongBao);
            }
        })
        .catch((err) => { throw err; });
};

export const xuatExcelLuongBoSungTruongBKS = async (id: number) => {
    var rs = null;
    await intance.get(ApiPaths.luong.xuatExcelLuongBoSungTruongBKS + "?id=" + id, { responseType: 'blob' })
        .then((res) => {
            rs = res;
        })
        .catch((err) => {
            throw 'Có lỗi xảy ra. Vui lòng thử lại';
        });
    return rs;
};

// Lương thêm giờ
export const timKiemDsLuongThemGio = async (start: number, length: number, thangNam?: string) => {
    var rs: any = { data: [], recordsTotal: 0 };
    let formData = new FormData();
    formData.append("start", start.toString());
    formData.append("length", length.toString());
    if (thangNam) {
        formData.append("thangNam", thangNam);
    }
    await intance.post(ApiPaths.luong.timKiemDsLuongThemGio, formData, {
        headers: {
            "Content-Type": "multipart/form-data",
            "Accept": "application/json",
        },
    }).then((res) => {
        if (res.data.trangThai === responseStatus.thanhCong) {
            rs = res.data.duLieu;
        } else {
            throw new Error(res.data.thongBao);
        }
    }).catch((err) => {
        throw err;
    });
    return rs;
};

export const layDsLuongThemGioTheoNam = async (nam?: number) => {
    var rs: Array<any> = [];
    const qs = nam ? `?nam=${nam}` : '';
    await intance.get(ApiPaths.luong.layDsLuongThemGioTheoNam + qs).then((res) => {
        if (res.data.trangThai === responseStatus.thanhCong) {
            rs = res.data.duLieu;
        } else {
            throw new Error(res.data.thongBao);
        }
    }).catch((err) => {
        throw err;
    });
    return rs;
};

export const khoiTaoLuongThemGio = async (request: any) => {
    var rs = 0;
    await intance.post(ApiPaths.luong.khoiTaoLuongThemGio, request).then((res) => {
        if (res.data.trangThai === responseStatus.thanhCong) {
            rs = res.data.duLieu;
        } else {
            throw new Error(res.data.thongBao);
        }
    }).catch((err) => {
        throw err;
    });
    return rs;
};

export const layThongTinLuongThemGio = async (id: number) => {
    var rs: any = null;
    await intance.get(ApiPaths.luong.layThongTinLuongThemGio + "?id=" + id).then((res) => {
        if (res.data.trangThai === responseStatus.thanhCong) {
            rs = res.data.duLieu;
        } else {
            throw new Error(res.data.thongBao);
        }
    }).catch((err) => {
        throw err;
    });
    return rs;
};

export const taiDuLieuLuongThemGio = async (id: number) => {
    var rs: Array<any> = [];
    await intance.get(ApiPaths.luong.taiDuLieuLuongThemGio + "?id=" + id).then((res) => {
        if (res.data.trangThai === responseStatus.thanhCong) {
            rs = res.data.duLieu;
        } else {
            throw new Error(res.data.thongBao);
        }
    }).catch((err) => {
        throw err;
    });
    return rs;
};

export const chiTietLuongThemGio = async (id: number) => {
    var rs: Array<any> = [];
    await intance.get(ApiPaths.luong.chiTietLuongThemGio + "?id=" + id).then((res) => {
        if (res.data.trangThai === responseStatus.thanhCong) {
            rs = res.data.duLieu;
        } else {
            throw new Error(res.data.thongBao);
        }
    }).catch((err) => {
        throw err;
    });
    return rs;
};

export const luuLuongThemGio = async (request: any) => {
    await intance.post(ApiPaths.luong.luuLuongThemGio, request).then((res) => {
        if (res.data.trangThai !== responseStatus.thanhCong) {
            throw new Error(res.data.thongBao);
        }
    }).catch((err) => {
        throw err;
    });
};

export const duyetLuongThemGio = async (id: number) => {
    await intance.post(ApiPaths.luong.duyetLuongThemGio + "?id=" + id).then((res) => {
        if (res.data.trangThai !== responseStatus.thanhCong) {
            throw new Error(res.data.thongBao);
        }
    }).catch((err) => {
        throw err;
    });
};

export const luuDieuChinhChiTietLuongThemGio = async (request: any) => {
    await intance.post(ApiPaths.luong.luuDieuChinhChiTietLuongThemGio, request).then((res) => {
        if (res.data.trangThai !== responseStatus.thanhCong) {
            throw new Error(res.data.thongBao);
        }
    }).catch((err) => {
        throw err;
    });
};

export const xuatExcelLuongThemGio = async (id: number) => {
    var rs = null;
    await intance.get(ApiPaths.luong.xuatExcelLuongThemGio + "?id=" + id, { responseType: 'blob' })
        .then((res) => {
            rs = res;
        })
        .catch((err) => {
            throw 'Có lỗi xảy ra. Vui lòng thử lại';
        });
    return rs;
};

//// ----- LƯƠNG THÁNG ----- ////

// Lấy danh sách lương tháng
export const layDsLuongThang = async (start: number, length: number, thangNam?: string) => {
    var rs: any = {
        data: [],
        recordsTotal: 0,
    };
    var qs = `?start=${start}&length=${length}`;
    if (thangNam) qs += `&thangNam=${thangNam}`;
    await intance.get(ApiPaths.luong.layDsLuongThang_V2 + qs)
        .then((res) => {
            if (res.data.trangThai == responseStatus.thanhCong) {
                rs = res.data.duLieu;
            } else {
                throw Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
    return rs;
};

// Khởi tạo lương tháng
export const khoiTaoLuongThang = async (request: {
    thangNam: string,
    dsIdLuongKhenThuongUngHo: number[],
    dsIdLuongCoBan: number[],
    dsIdLuongPhuCap: number [],
    dsIdLuongThemGio: number [],
    dsIdLuongHTNV: number [],
    dsIdLuongBSTBKS: number [],
    dsIdLuongThuLaoKCT: number [],
    dsIdLuongPhuCapTGV: number [],
}) => {
    var rs: any = null;
    await intance.post(ApiPaths.luong.khoiTaoLuongThang_V2, request)
        .then((res) => {
            if (res.data.trangThai == responseStatus.thanhCong) {
                rs = res.data.duLieu;
            } else {
                throw Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
    return rs;
};

// Lấy danh sách lương cơ bản theo năm (dùng cho modal chọn khoản lương thành phần)
export const layDsLuongCoBanTheoNam = async (nam?: number) => {
    var rs: Array<any> = [];
    const qs = nam ? `?nam=${nam}` : '';
    await intance.get(ApiPaths.luong.layDsLuongCoBanTheoNam + qs)
        .then((res) => {
            if (res.data.trangThai == responseStatus.thanhCong) {
                rs = res.data.duLieu;
            } else {
                throw Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
    return rs;
};

// Lấy thông tin chung lương tổng hợp tháng
export const layThongTinLuongThang = async (id: number) => {
    var rs: any = null;
    await intance.get(ApiPaths.luong.layThongTinLuongThang_V2 + '?id=' + id)
        .then((res) => {
            if (res.data.trangThai == responseStatus.thanhCong) {
                rs = res.data.duLieu;
            } else {
                throw Error(res.data.thongBao);
            }
        })
        .catch((err) => { throw err; });
    return rs;
};

// Tính/tải chi tiết lương tổng hợp tháng
export const taiLuongThang = async (id: number) => {
    var rs: Array<any> = [];
    await intance.get(ApiPaths.luong.taiLuongThang_V2 + '?id=' + id)
        .then((res) => {
            if (res.data.trangThai == responseStatus.thanhCong) {
                rs = res.data.duLieu;
            } else {
                throw Error(res.data.thongBao);
            }
        })
        .catch((err) => { throw err; });
    return rs;
};

// Lấy chi tiết lương tháng đã lưu
export const layChiTietLuongThang = async (id: number) => {
    var rs: Array<any> = [];
    await intance.get(ApiPaths.luong.layChiTietLuongThang_V2 + '?id=' + id)
        .then((res) => {
            if (res.data.trangThai == responseStatus.thanhCong) {
                rs = res.data.duLieu;
            } else {
                throw Error(res.data.thongBao);
            }
        })
        .catch((err) => { throw err; });
    return rs;
};

// Lưu chi tiết lương tháng
export const luuLuongThang = async (request: { id: number; chiTiet: any[] }) => {
    await intance.post(ApiPaths.luong.luuLuongThang_V2, request)
        .then((res) => {
            if (res.data.trangThai !== responseStatus.thanhCong) {
                throw Error(res.data.thongBao);
            }
        })
        .catch((err) => { throw err; });
};

// Duyệt lương cơ bản / Xác nhận thực nhận
export const duyetLuongThang = async (id: number) => {
    await intance.post(ApiPaths.luong.duyetLuongThang_V2 + '?id=' + id)
        .then((res) => {
            if (res.data.trangThai !== responseStatus.thanhCong) {
                throw Error(res.data.thongBao);
            }
        })
        .catch((err) => { throw err; });
};

// Xác nhận trước thuế tổng hợp lương
export const xacNhanTruocThueLuongThang = async (id: number) => {
    await intance.post(ApiPaths.luong.xacNhanTruocThueLuongThang_V2 + '?id=' + id)
        .then((res) => {
            if (res.data.trangThai !== responseStatus.thanhCong) {
                throw Error(res.data.thongBao);
            }
        })
        .catch((err) => { throw err; });
};

// Xác nhận thực nhận tổng hợp lương (Khóa toàn bộ)
export const xacNhanThucNhanLuongThang = async (id: number) => {
    await intance.post(ApiPaths.luong.xacNhanThucNhanLuongThang_V2 + '?id=' + id)
        .then((res) => {
            if (res.data.trangThai !== responseStatus.thanhCong) {
                throw Error(res.data.thongBao);
            }
        })
        .catch((err) => { throw err; });
};

// Cập nhật dữ liệu tham chiếu lương cơ bản
export const capNhatDuLieuThamChieuLuongThang = async (request: any) => {
    await intance.post(ApiPaths.luong.capNhatDuLieuThamChieuLuongThang_V2, request)
        .then((res) => {
            if (res.data.trangThai !== responseStatus.thanhCong) {
                throw Error(res.data.thongBao);
            }
        })
        .catch((err) => { throw err; });
};

export const xuatExcelLuongThang = async (id: number) => {
    var rs: any;
    await intance.get(ApiPaths.luong.xuatExcelLuongThang_V2 + "?id=" + id, { responseType: 'blob' })
        .then((res) => {
            rs = res;
        })
        .catch((err) => {
            throw 'Có lỗi xảy ra. Vui lòng thử lại';
        });
    return rs;
};
export const layThuNhapLuongThangCaNhan = async (thang: number, nam: number) => {
    var rs: any = null;
    await intance.get(ApiPaths.luong.layThuNhapLuongThangCaNhan + "?thang=" + thang + "&nam=" + nam)
        .then((res) => {
            if (res.data.trangThai == responseStatus.thanhCong) {
                rs = res.data.duLieu;
            } else {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => { throw err; });
    return rs;
};

export const xoaBangLuong = async (id: number) => {
    await intance.post(ApiPaths.luong.xoaBangLuong + "?id=" + id)
        .then((res) => {
            if (res.data.trangThai !== responseStatus.thanhCong) {
                throw Error(res.data.thongBao);
            }
        })
        .catch((err) => { throw err; });
};

export const xoaBangLuongCoBan = async (id: number) => {
    await intance.post(ApiPaths.luong.xoaBangLuongCoBan + "?id=" + id)
        .then((res) => {
            if (res.data.trangThai !== responseStatus.thanhCong) {
                throw Error(res.data.thongBao);
            }
        })
        .catch((err) => { throw err; });
};

export const xoaBangLuongPhuCap = async (id: number) => {
    await intance.post(ApiPaths.luong.xoaBangLuongPhuCap + "?id=" + id)
        .then((res) => {
            if (res.data.trangThai !== responseStatus.thanhCong) {
                throw Error(res.data.thongBao);
            }
        })
        .catch((err) => { throw err; });
};

export const xoaBangLuongThemGio = async (id: number) => {
    await intance.post(ApiPaths.luong.xoaBangLuongThemGio + "?id=" + id)
        .then((res) => {
            if (res.data.trangThai !== responseStatus.thanhCong) {
                throw Error(res.data.thongBao);
            }
        })
        .catch((err) => { throw err; });
};

export const xoaBangLuongHoanThanhNhiemVu = async (id: number) => {
    await intance.post(ApiPaths.luong.xoaBangLuongHoanThanhNhiemVu + "?id=" + id)
        .then((res) => {
            if (res.data.trangThai !== responseStatus.thanhCong) {
                throw Error(res.data.thongBao);
            }
        })
        .catch((err) => { throw err; });
};

export const xoaBangLuongBoSungTruongBKS = async (id: number) => {
    await intance.post(ApiPaths.luong.xoaBangLuongBoSungTruongBKS + "?id=" + id)
        .then((res) => {
            if (res.data.trangThai !== responseStatus.thanhCong) {
                throw Error(res.data.thongBao);
            }
        })
        .catch((err) => { throw err; });
};
